module.exports = __webpack_public_path__ + "static/media/sub-modal-2.ee29891b.jpg";